/**
 * 判断当前页面是否在iframe里 ，
 * 主要作用还是判断是否嵌入自己页面里边的比如im中，需要做些业务处理，但是嵌入第三方域名不能影响这些业务
 * true = in iframe
 * false = not in iframe
 */
export function isInIframe() {
    let inFrame = false;
    try {
        inFrame = window.self !== window.parent;
    } catch (e) {
        inFrame = true;
    }
    return inFrame;
}

export const AUTH = {
    REGISTER_PAGE: '/auth/register',
    REGISTER_STEP_1: 'register',
    REGISTER_STEP_1_BIND: 'bind',
    REGISTER_STEP_2: 'profile',
    REGISTER_STEP_3: 'identity',

    LOGIN_PAGE: '/auth/login',
    FORGET_PAGE: '/auth/forget',
    RESET_PAGE: '/auth/reset'
}

export function getPinUrl() {
    //test是兼容本地调试的情况, m, pc通用一个规则
    const pinUrl = location.protocol + '//pin.' + location.host.replace(/^(test\.)?((www|m)\.)?/, '');
    return pinUrl;
}
